const datePickerLocalization = {
  modalHeading: "Choose a date",
  closeLabel: "Close window",
  buttonLabel: "Choose date",
  selectedDateMessage: "Selected date is",
}

export default datePickerLocalization
